/* eslint-disable filenames/match-regex */
import PropTypes from 'prop-types';
import React from 'react';

/**
 * Render structured data inline so it is present in server-rendered HTML.
 *
 * @param {object} props
 * @param {object|array} props.item Structured data payload.
 *
 * @return {object|null} JSON-LD script element.
 */
export default function JsonLd({ item }) {
    if (!item) return null;

    const json = JSON.stringify(item)
        .replace(/</g, '\\u003c')
        .replace(/\u2028/g, '\\u2028')
        .replace(/\u2029/g, '\\u2029');

    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: json }}
        />
    );
}

JsonLd.propTypes = {
    item: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array
    ])
};
